module.exports = new __parcel__URL__("pvp_player_divider.76d6c83d.png").toString();